// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tFHOK","controls":"styles_controls__wkFaD","charLimit":"styles_charLimit__g0NQs","input":"styles_input__1cClc","send":"styles_send__1sdKZ"};